// CANONICAL COPY (GH #7115). src/constants/obligations/obl-asset-return.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-asset-return',
  title: 'Verify asset return process for leavers',
  description:
    'Confirm that all departing employees have returned all organisation assets. Either the central asset registry showing no outstanding assignments to leavers, or the JML leaver checklist marking asset-return complete, satisfies this obligation.',
  category: 'assets',
  scfIds: ['SCF-AST-003'],
  cadence: { frequency: '3m', anchor: 'domain' },
  strategy: 'any',
  fulfilmentCriteria: [
    {
      type: 'assets-returned-by-leavers',
      description:
        'No assets in the central registry are still assigned to a leaver or departed employee',
    },
    {
      type: 'employees-assets-returned',
      description: 'All leavers have returned assets (JML checklist)',
    },
  ],
  domainActions: [{ type: 'deep-link', target: 'employees', label: 'Review Employee Records' }],
};
